// MAP Marker defaults - p;xels
export const MARKER_HEIGHT_INACTIVE= 20
export const MARKER_WIDTH_INACTIVE = 20
export const MARKER_HEIGHT_ACTIVE = 30
export const MARKER_WIDTH_ACTIVE = 30

export const OPENCAGE_GEOCODE_BASE_URL = 'https://api.opencagedata.com/geocode/v1/json'